export const STEPS = [
  { title: "Tell us about yourself", description: "Your details" },
  { title: "Choose package", description: "Select your plan" },
  { title: "Participants", description: "Add participants" },
];

export const REASON_OPTIONS = [
  { value: "recreation", label: "Recreation" },
  { value: "business", label: "Business idea search" },
  { value: "manufacturers", label: "Search for manufacturers" },
];

export const HEAR_OPTIONS = [
  { value: "social", label: "Social media" },
  { value: "word", label: "Word of mouth" },
  { value: "website", label: "Website" },
];

export const DAYS_OPTIONS = [
  { value: "14", label: "14 days" },
  { value: "21", label: "21 days" },
];

import { TRAVEL_SERVICE_TYPES } from "@features/services/travel/travelServiceEvents";

export const CUSTOM_SERVICE_OPTIONS = TRAVEL_SERVICE_TYPES.map((s) => s.label);

export type PackageType = "standard" | "premium" | "custom";

export interface Step1Data {
  name: string;
  phone: string;
  yearOfBirth: string;
  profession: string;
  reasonForTravel: string;
  howDidYouHear: string;
}

export interface Participant {
  id: string;
  name: string;
}

export const inputProps = {
  borderColor: "border.dark",
  _hover: { borderColor: "border.dark" },
} as const;

export const selectFieldProps = {
  borderColor: "border.dark",
} as const;

// Query param constants
export const VIEW_PARAM = "view";
export const TRACKING_PARAM = "tracking";
// Validation
const MIN_BIRTH_YEAR = 1900;
const MAX_BIRTH_YEAR = new Date().getFullYear() - 16;

export const isValidBirthYear = (value: string): boolean => {
  if (value.trim() === "") {
    return false;
  }
  const year = Number(value);
  return (
    Number.isInteger(year) && year >= MIN_BIRTH_YEAR && year <= MAX_BIRTH_YEAR
  );
};

export const getBirthYearError = (value: string): string | null => {
  if (value.trim() === "") {
    return null;
  }
  const year = Number(value);
  if (!Number.isInteger(year) || String(year) !== value.trim()) {
    return "Enter a valid year";
  }
  if (year < MIN_BIRTH_YEAR) {
    return `Year must be ${MIN_BIRTH_YEAR} or later`;
  }
  if (year > MAX_BIRTH_YEAR) {
    return "You must be at least 16 years old";
  }
  return null;
};
